import { logger } from '../services/logger/logger';

/**
 * Prefix for keys owned by this application.
 * Any key starting with these prefixes will be cleared on logout/session expiry.
 */
const APP_STORAGE_PREFIXES = [
  'persist:',
  'msal.',
  'priceList_doc_',
  'delivery_grid_state',
  'robs_grid_state',
  'delivery_edits_',
  'i18nextLng',
  'post_login_redirect',
];

/**
 * Clears only the localStorage and sessionStorage keys that belong to this application.
 * This avoids affecting other applications hosted on the same domain/origin.
 */
export const clearAppStorage = () => {
  try {
    const storages = [localStorage, sessionStorage];

    storages.forEach((storage) => {
      // Get all keys first to avoid issues with concurrent modification if any
      const keys = Object.keys(storage);

      keys.forEach((key) => {
        if (APP_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))) {
          storage.removeItem(key);
        }
      });
    });
  } catch (error) {
    logger.error('Failed to clear application storage:', error as Error);
  }
};

/**
 * Remembers the page an unauthenticated user tried to open so login can return them to it.
 */
const POST_LOGIN_REDIRECT_KEY = 'post_login_redirect';

export const savePostLoginRedirect = (path: string) => {
  try {
    if (path && path !== '/' && path !== '/unauthorized') {
      sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
    }
  } catch (error) {
    logger.error('Failed to save post-login redirect:', error as Error);
  }
};

export const getPostLoginRedirect = (): string | null => {
  try {
    const path = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    // Only allow in-app absolute paths
    return path && path.startsWith('/') && !path.startsWith('//') ? path : null;
  } catch {
    return null;
  }
};

export const clearPostLoginRedirect = () => {
  try {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  } catch {
    // ignore
  }
};
